import * as React from 'react';
import { 
  Box,
  DialogContent,
} from '@mui/material';
import { CDialog, CDialogTitle, CDialogActions, CButton } from '../components/common/Modal';

import BarChart from '../components/Charts/BarChart';

import ColorItem from '../components/ColorPicker/ColorItem';

const templateData = [
  {
      label: "A",
      value: 400
  },
  {
      label: "B",
      value: 685
  },
  {
      label: "C",
      value: 490
  },
  {
      label: "D",
      value: 600
  },
  {
      label: "E",
      value: 335
  },
  {
      label: "F",
      value: 781
  },
  {
      label: "G",
      value: 898
  },
  {
      label: "H",
      value: 177
  },
];

export default function ColorModal(props) {
  const {open, value, handleSave, handleClose} = props;
  const [color, setColor] = React.useState(value);

  const handleColor = (id, item) => {
    setColor(prev => {
      let newColor = [...prev];
      newColor[id] = item;
      return newColor;
    });
  }
 
  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"xs"}
        fullWidth
      >
        <CDialogTitle>Edit Color</CDialogTitle>
        <DialogContent>
          <Box className="color-grid" sx={{marginTop: '20px'}}>
            {
              Array.from({length: 8}).map((i, index)=> <ColorItem key={index} id={index} color={color[index]} onChange={handleColor} />)
            }
          </Box>
          <Box className="w-full" sx={{mt: 1}}>
            <BarChart
              width={400}
              height={200}
              data={templateData}
              color={color}
            />
          </Box>
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={() => handleSave(color)}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}